import { render, staticRenderFns } from "./MotorDecisionAid.vue?vue&type=template&id=6986eb77&scoped=true"
import script from "./MotorDecisionAid.vue?vue&type=script&lang=js"
export * from "./MotorDecisionAid.vue?vue&type=script&lang=js"
import style0 from "./MotorDecisionAid.vue?vue&type=style&index=0&id=6986eb77&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6986eb77",
  null
  
)

export default component.exports